<template>
  <div class="quantity-selector flex items-center gap-100">
    <LcButton
      :aria-label="$t('picklottery.quickpick.quantity.arialabel.decrement')"
      class="button"
      :disabled="value <= min"
      icon="minus"
      size="medium"
      variant="tertiary"
      @click="decrement"
    />
    <LcInput
      v-bind="{
        min,
        max,
      }"
      v-model:value="value"
      class="input input-bold text-center"
      no-feedback
      type="number"
    />
    <LcButton
      :aria-label="$t('picklottery.quickpick.quantity.arialabel.increment')"
      class="button"
      :disabled="typeof max === 'number' && value >= max"
      icon="plus"
      size="medium"
      variant="tertiary"
      @click="increment"
    />
  </div>
</template>

<script lang="ts" setup>
type QuantitySelectorProps = {
  max?: number
  min?: number
}

const { max = Infinity, min = 1 } = defineProps<QuantitySelectorProps>()

const value = defineModel('value', {
  default: 1,
  type: Number,
})

const decrement = () => {
  if (value.value <= min) return
  value.value -= 1
}

const increment = () => {
  if (value.value >= max) return
  if (typeof value.value !== 'number') {
    value.value = min
    return
  }
  value.value += 1
}
</script>

<style lang="scss" scoped>
.quantity-selector {
  .button {
    border: 0.0625rem solid token('color/border/primary/primary');
    border-radius: token('size/radius/l');
    background-color: token('color/background/accent/info/info-extralight');

    &:disabled {
      border-color: token('color/background/secondary/secondary-disabled');
      background-color: token('color/background/primary/primary');
    }
  }

  .input {
    width: 3.125rem;

    /* stylelint-disable-next-line selector-class-pattern */
    :deep(.lc-input__wrap) {
      padding: 0;
    }
  }
}
</style>
